function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ALGOLIA_PLP_FACETS, ALGOLIA_PRICE_ATTRIBUTE, getAlgoliaSortReplicas } from './constants';
var SORT_ATTRIBUTE = 'sort';
function slugify(str) {
  return String(str).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
function sortIndexFromLabel(sortReplicas, label) {
  var match = sortReplicas.find(r => (r.urlKey || slugify(r.label)) === label);
  return match ? match.value : null;
}

/**
 * @param {string} value
 * @returns {{ min: number | null, max: number | null } | null}
 */
function parsePriceRangeValue(value) {
  var s = String(value !== null && value !== void 0 ? value : '').trim();
  if (!s) return null;
  var dash = s.indexOf('-');
  var minPart = dash === -1 ? s : s.slice(0, dash).trim();
  var maxPart = dash === -1 ? '' : s.slice(dash + 1).trim();
  var min = minPart !== '' ? Number(minPart) : null;
  var max = maxPart !== '' ? Number(maxPart) : null;
  if (min !== null && Number.isNaN(min) || max !== null && Number.isNaN(max)) {
    return null;
  }
  if (min === null && max === null) return null;
  return {
    min,
    max
  };
}

/**
 * @param {Array<{ attribute?: string, value?: string }>} entries
 * @param {{ facets?: Array, sortReplicas?: Array }} [options]
 * @returns {{ refinements: Record<string, string[]>, numericRange: Record<string, { min: number | null, max: number | null }>, sortIndex?: string }}
 */
export function normalizePreselectedFilters(entries) {
  var _options$facets, _options$sortReplicas;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var facets = (_options$facets = options.facets) !== null && _options$facets !== void 0 ? _options$facets : ALGOLIA_PLP_FACETS;
  var sortReplicas = (_options$sortReplicas = options.sortReplicas) !== null && _options$sortReplicas !== void 0 ? _options$sortReplicas : getAlgoliaSortReplicas();
  var validAttributes = new Set(facets.map(f => f.type === 'rangeInput' ? ALGOLIA_PRICE_ATTRIBUTE : f.attribute));
  validAttributes.add(SORT_ATTRIBUTE);

  /** @type {Record<string, string[]>} */
  var refinements = {};
  /** @type {Record<string, { min: number | null, max: number | null }>} */
  var numericRange = {};
  /** @type {string | undefined} */
  var sortIndex;
  for (var entry of entries || []) {
    var _entry$attribute, _entry$value;
    var attribute = String((_entry$attribute = entry === null || entry === void 0 ? void 0 : entry.attribute) !== null && _entry$attribute !== void 0 ? _entry$attribute : '').trim();
    var value = String((_entry$value = entry === null || entry === void 0 ? void 0 : entry.value) !== null && _entry$value !== void 0 ? _entry$value : '').trim();
    if (!attribute || !value) continue;
    if (attribute === SORT_ATTRIBUTE) {
      var resolved = sortIndexFromLabel(sortReplicas, value);
      if (resolved) {
        sortIndex = resolved;
      } else {
        console.warn('[Algolia] Unknown preselected sort slug:', value);
      }
      continue;
    }
    if (attribute === ALGOLIA_PRICE_ATTRIBUTE) {
      var range = parsePriceRangeValue(value);
      if (range) {
        numericRange[ALGOLIA_PRICE_ATTRIBUTE] = range;
      }
      continue;
    }
    if (!validAttributes.has(attribute)) {
      console.warn('[Algolia] Unknown preselected filter attribute:', attribute);
      continue;
    }
    if (!refinements[attribute]) {
      refinements[attribute] = [];
    }
    if (!refinements[attribute].includes(value)) {
      refinements[attribute].push(value);
    }
  }
  return {
    refinements,
    numericRange,
    sortIndex
  };
}

/**
 * Merge collection preselected defaults into URL-derived state.
 * URL wins per attribute when present.
 *
 * Note: refinement/price presence is inferred from `state`. Sort needs an
 * explicit `urlHadSort` flag because URL `sort=featured` may resolve to the
 * default index and become indistinguishable from "no sort param".
 *
 * @param {object} state
 * @param {ReturnType<normalizePreselectedFilters>} defaults
 * @param {{ urlHadSort?: boolean, defaultSortIndex?: string }} [options]
 */
export function mergePreselectedDefaults(state, defaults) {
  var _defaults$numericRang;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!defaults) return state;
  var merged = _objectSpread(_objectSpread({}, state), {}, {
    refinements: _objectSpread({}, state.refinements),
    numericRange: _objectSpread({}, state.numericRange)
  });
  for (var _ref3 of Object.entries(defaults.refinements || {})) {
    var _merged$refinements$a;
    var _ref2 = _slicedToArray(_ref3, 2);
    var attr = _ref2[0];
    var values = _ref2[1];
    if (values !== null && values !== void 0 && values.length && !((_merged$refinements$a = merged.refinements[attr]) !== null && _merged$refinements$a !== void 0 && _merged$refinements$a.length)) {
      merged.refinements[attr] = [...values];
    }
  }
  var defaultPrice = (_defaults$numericRang = defaults.numericRange) === null || _defaults$numericRang === void 0 ? void 0 : _defaults$numericRang[ALGOLIA_PRICE_ATTRIBUTE];
  if (defaultPrice && !merged.numericRange[ALGOLIA_PRICE_ATTRIBUTE]) {
    merged.numericRange[ALGOLIA_PRICE_ATTRIBUTE] = _objectSpread({}, defaultPrice);
  }
  if (defaults.sortIndex && !options.urlHadSort && merged.sortIndex === options.defaultSortIndex) {
    merged.sortIndex = defaults.sortIndex;
  }
  return merged;
}

/**
 * @param {HTMLElement} root
 * @param {{ facets?: Array, sortReplicas?: Array }} [options]
 * @returns {ReturnType<normalizePreselectedFilters> | null}
 */
export function parsePreselectedFiltersFromRoot(root) {
  var _root$dataset;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var raw = root === null || root === void 0 || (_root$dataset = root.dataset) === null || _root$dataset === void 0 ? void 0 : _root$dataset.algoliaDefaultFilters;
  if (!raw) return null;
  try {
    var entries = JSON.parse(raw);
    if (!Array.isArray(entries) || !entries.length) return null;
    return normalizePreselectedFilters(entries, options);
  } catch (_unused) {
    console.warn('[Algolia] Invalid data-algolia-default-filters JSON');
    return null;
  }
}